module.exports = __webpack_public_path__ + "static/img/xi_11.b2c36f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_11.jpg
// module id = 7IBj
// module chunks = 1